/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_Cta_TitleInputs */

const en_pb_cta_title = /** @type {(inputs: Pb_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Have your own idea?`)
};

const id_pb_cta_title = /** @type {(inputs: Pb_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punya ide sendiri?`)
};

/**
* | output |
* | --- |
* | "Have your own idea?" |
*
* @param {Pb_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_cta_title = /** @type {((inputs?: Pb_Cta_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_Cta_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_cta_title(inputs)
	return en_pb_cta_title(inputs)
});